import React from 'react';
import styled, { css } from 'styled-components';
import { zIndex } from '../global/globals';
import { ReactComponent as IconLogo } from '../../figures/logo-briet.svg';
import { ReactComponent as IconLogoMobile } from '../../figures/logo-primary.svg';
import media from '../base/media';
import { Hamburger } from '../base';

export const navItemTransitionLength = '150ms';

export const Header = styled.header `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: ${zIndex.header};
`;

export const HeaderBackground = styled.div `
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: ${props => props.theme.header.headerHeightMobile};
	background: ${props => props.theme.header.headerBackground};
	z-index: -1;
	transition: transform 250ms ease, background ${props => props.theme.theming.nightDayTransitionDuration} ease;
	transform: translate3d(0, -100%, 0);

	${media.desktopSmall`
		height: ${props => props.theme.header.headerHeightDesktop};
		background: ${props => props.theme.header.headerBackground};
	`}

	${({ scrolled }) =>
		scrolled &&
		css`
			transform: translate3d(0, 0, 0);
		`}
`;

export const HeaderInner = styled.div`
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	height: ${props => props.theme.header.headerHeightMobile};
	padding: 0 3rem;
	max-width: calc(192rem + 12rem);
	margin: 0 auto;

	${media.tablet`
		padding: 0 4rem;
	`}

	${media.desktopSmall`
		height: ${props => props.theme.header.headerHeightDesktop};
	`}

	${media.desktopLarge`
		padding: 0 6rem;
	`}
`;

export const SubNavItem = styled.div`
	> a {
		font-size: 1.6rem;
		font-weight: 600px;
		line-height: 1.6;
		color: ${({ theme }) => theme.colors.grayDarker};

		&:hover {
			color: ${({ theme }) => theme.colors.grayDarker2};
		}
	}
`;

export const SubNav = styled.div`
	position: absolute;
	top: 9.3rem;
	left: 1.5rem;
	width: 28rem;
	padding: 2.5rem 3.5rem;
	z-index: ${zIndex.header};
	box-shadow: 0 10px 24px 0 rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	background-color: #fff;
	transform: translate3d(0, 10px, 0);
	opacity: 0;
	pointer-events: none;
	transition: transform 200ms ease, opacity 200ms ease;
`;

export const AnchorAnimation = styled.div`
	position: relative;

	&:after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		height: 2px;
		width: 100%;
		opacity: 0;
		background-color: ${props => props.theme.colors.primaryLighter3};
		box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1);
		transform: translate3d(0, -5px, 0);
		transition: opacity ${navItemTransitionLength} ease, transform ${navItemTransitionLength} ease;
	}
`;

export const NavItem = styled.div`
	position: relative;
	display: flex;
	align-items: stretch;

	&:hover {
		${SubNav} {
			opacity: 1;
			transform: translate3d(0, 0, 0);
			pointer-events: all;
		}
	}

	> a {
		display: flex;
		align-items: center;
		color: ${props => props.theme.colors.headerTextColor};
		font-weight: 600;
		font-size: 1.4rem;
		padding: 0 1.5rem;
		transition-duration: ${navItemTransitionLength};

		&:hover {
			color: ${props => props.theme.colors.primary};

			${AnchorAnimation} {
				&:after {
					opacity: 1;
					transform: translate3d(0, 5px, 0);
				}
			}
		}
	}
`;

export const LogoWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: stretch;

	> a {
		display: flex;
		align-items: center;
		margin-left: -3rem;
		padding: 0 3rem;

		svg text {
			transition: fill ${props => props.theme.theming.nightDayTransitionDuration} ease;
			fill: ${props => props.theme.colors.logoTextColor};
		}
	}
`;

export const Logo = styled(IconLogo)`
	display: none;
	height: 40px;
	padding: 0 20px;

	${media.desktopLarge`
		display: block;`}
`;

export const MobileLogo = styled(IconLogoMobile)`
	display: flex;

	${media.desktopLarge`
		display: none;
	`}
`;

export const StyledHamburger = styled(Hamburger)``;

export const StyledBurgerWrapper = styled.div`
	display: flex;
	align-items: center;

	${media.desktopSmall`
		display: none;
	`}
`;

export const MobileHamburger = props => (
	<StyledBurgerWrapper>
		<StyledHamburger {...props} />
	</StyledBurgerWrapper>
);

export const Navigation = styled.nav`
	display: flex;
	align-items: stretch;

	${media.mobileOnly`display: none;`}
	${media.tabletOnly`display: none;`}
`;

export const ContentWrapper = styled.div`
	display: flex;
	align-items: stretch;
`;

export const Tools = styled.div`
	display: flex;
	align-items: center;

	${media.desktopSmall`
		margin-left: 2rem;
	`}

	${media.desktopLarge`
		margin-left: 13rem;
	`}

	${media.mobileOnly`
		svg {
			display: none;
		}
		a {
			margin-right: 20px;
			height: 4rem;
			padding: 0 1.5rem;
		}
	`}
	${media.tabletOnly`
		svg {
			display: none;
		}
		a {
			margin-right: 20px;
			height: 4rem;
			padding: 0 1.5rem;
		}
	`}
`;